import { noAuthAxios } from "./api"

export const QUERY_KEY = "categories"
export const BASE_URL = "app/categories/"

export const listCategories = () => noAuthAxios.get(BASE_URL)

